module.exports = __webpack_public_path__ + "static/media/loader.a3c1c5cc.gif";